import React, {Component} from 'react';
import Pageheading from '../../../widgets/Pageheading';
import {toast} from 'react-toastify';

class Career extends Component {
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            email: '',
            phone: '',
            message: '',
            submitted: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        const {email, phone, message, name} = this.state;

        try {
            const response = await fetch('https://apis.windeal.co.ke/postdata', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': 'qyfCv4sBd0fcquNZijY9nhN7szU4a7KS'
                },
                body: JSON.stringify({
                    organisation: 'nafsi',
                    rpcQueue: 'nafsi',
                    menu: 'notification',
                    method: 'saveWebsiteSubmission',
                    type: 'CAREER',
                    name,
                    email,
                    phone,
                    message
                })
            });

            const data = await response.json();
            const result = JSON.parse(data.result);
            if (result?.v_field39 === '00') {
                this.setState({
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                    submitted: true
                });

                setTimeout(() => {
                    this.setState({submitted: false});
                }, 5000);
            } else {
                toast.error(
                    data?.v_field48 || 'Failed to submit your request. Please try again.'
                );
            }
        } catch (error) {
            toast.error('Network error. Please check your connection.');
        }


    }

    render() {
        return (
            <div>
                {/*hero section start*/}
                <section className="position-relative">
                    <Pageheading foldername={'Company'} title={'Careers'}/>
                </section>
                {/*hero section end*/}
                {/*body content start*/}
                <div className="page-content">
                    <section>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-md-10">
                                    <div className="text-center mb-5">
                                        <h2 className="mb-3">Join Our Team</h2>
                                        <p className="lead">Leave your details and we will get back to you</p>
                                    </div>

                                    {this.state.submitted ? (
                                        <div className="alert alert-success text-center" role="alert">
                                            <h4 className="alert-heading">Thank you!</h4>
                                            <p>We have received your information and will get back to you soon.</p>
                                        </div>
                                    ) : (
                                        <form onSubmit={this.handleSubmit}>
                                            <div className="form-group">
                                                <label htmlFor="name">Full Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    name="name"
                                                    value={this.state.name}
                                                    onChange={this.handleInputChange}
                                                    required
                                                    placeholder="Enter your full name"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="email">Email Address *</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="email"
                                                    name="email"
                                                    value={this.state.email}
                                                    onChange={this.handleInputChange}
                                                    required
                                                    placeholder="your.email@example.com"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="phone">Phone Number</label>
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    id="phone"
                                                    name="phone"
                                                    value={this.state.phone}
                                                    onChange={this.handleInputChange}
                                                    placeholder="+254 XXX XXX XXX"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="message">Tell us about yourself</label>
                                                <textarea
                                                    className="form-control"
                                                    id="message"
                                                    name="message"
                                                    rows="5"
                                                    value={this.state.message}
                                                    onChange={this.handleInputChange}
                                                    placeholder="Share your experience, skills, and why you'd like to join Nafsi..."
                                                ></textarea>
                                            </div>
                                            <div className="text-center mt-4">
                                                <button type="submit" className="btn btn-primary btn-lg">
                                                    Submit Application
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                {/*body content end*/}
            </div>
        );
    }
}

export default Career;
